module.exports = __webpack_public_path__ + "media/images/icons/minus-cd85b3d1b653e610ec5a0378e6fb14d7.svg";